// extracted by mini-css-extract-plugin
export default {"sideBarContainer":"_sidebar_sideBarContainer__y5dFQ","item":"_sidebar_item__h9hIE"};